var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"py-3 text-xs text-center text-black border-t border-black border-solid"},[_vm._v(" Website maintained by Activa Media. All Rights Reserved. ")])])
}]

export { render, staticRenderFns }